import React, { useState, useEffect, useCallback, useRef } from "react";
import PropTypes from "prop-types";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { FiUsers } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom"
import { withTranslation } from "react-i18next";
import { IoListOutline, IoTimeOutline, IoHomeOutline, IoEyeOutline, IoSettingsOutline, IoPieChartOutline } from "react-icons/io5";
import { RxCalendar } from "react-icons/rx";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { RiTeamLine } from "react-icons/ri";
import { VscFeedback } from "react-icons/vsc";
import { PiNetworkLight, PiListChecks } from "react-icons/pi";
import { SlBookOpen } from "react-icons/sl";
import { LuUserRoundPen } from "react-icons/lu";
import { AiOutlineFileText, AiOutlineClockCircle, AiOutlineCloseCircle, AiOutlineCalendar, AiOutlineComment, AiOutlineBranches } from "react-icons/ai";
import { BsCalendar4Event } from "react-icons/bs";
import { LiaComment, LiaClipboardListSolid } from "react-icons/lia";
import { GrDocumentPerformance } from "react-icons/gr";
import { HiOutlineRefresh } from "react-icons/hi";
import { FaUsersRectangle } from "react-icons/fa6";
import { IoLocationOutline } from "react-icons/io5";
import { PiMapPinArea } from "react-icons/pi";
import { AiOutlineSolution } from "react-icons/ai";


const SidebarContent = ({ t }) => {
  const location = useLocation();
  const ref = useRef();
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const path = location.pathname;
  const permissions = JSON.parse(localStorage?.getItem('permissions'));

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag
        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  function tToggle2() {
    var body = document.body;
    if (window.screen.width <= 992) {
      body.classList.toggle("sidebar-enable");
    }
  }

  const activeMenu = useCallback(() => {
    const pathName = location.pathname;
    const fullPath = pathName;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (fullPath === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  // Get available paths from permissions
  const availablePaths = permissions?.map(permission => permission.pageUrl);
  const permissionNames = permissions?.map(permission => permission.permissionName);

  // Handle menu item click
  const handleMenuItemClick = (itemPath) => {
    setSelectedMenuItem(itemPath);  // Set the active menu item
  };

  const getActiveItemStyle = (itemPath) => {
    return selectedMenuItem === itemPath ? { backgroundColor: "#f0f0f0" } : {};
  };

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {availablePaths.includes("/dashboard") && (
              <li>
                <Link to="/dashboard" className="waves-effect" onClick={() => { handleMenuItemClick("/dashboard"); tToggle2(); }}>
                  <IoHomeOutline size={20} className="me-2 mb-1" />
                  <span className="">{t("Dashboard")}</span>
                </Link>
              </li>
            )}
            {availablePaths.includes("/categories") && (
              <li>
                <Link to="/categories" className="waves-effect" onClick={() => { handleMenuItemClick("/categories"); tToggle2(); }}>
                  <IoListOutline size={23} className="me-2" />
                  <span>{t("Categories")}</span>
                </Link>
              </li>
            )}
            {availablePaths.includes("/departments") && (
              <li>
                <Link to="/departments" className="waves-effect" onClick={() => { handleMenuItemClick("/departments"); tToggle2(); }}>
                  <PiNetworkLight size={23} className="me-2" />
                  <span>{t("Departments")}</span>
                </Link>
              </li>
            )}
            {(availablePaths.includes("/catalogues") || availablePaths.includes("/createCatalogue")) && (
              <li>
                <Link to="/catalogues" className="waves-effect" onClick={() => { handleMenuItemClick("/catalogues"); tToggle2(); }}>
                  <SlBookOpen size={20} className="me-2" />
                  <span>{t("Catalogues")}</span>
                </Link>
              </li>
            )}
            {(availablePaths.includes("/customers") || availablePaths.includes("/createCustomer")) && (
              <li>
                <Link to="/customers" className="waves-effect" onClick={() => { handleMenuItemClick("/customers"); tToggle2() }}>
                  <HiOutlineUserGroup size={23} className="me-2 mb-1" />
                  <span>{t("Customers")}</span>
                </Link>
              </li>
            )}
            {availablePaths.includes("/users") && (
              <li>
                <Link to="/users" className="waves-effect d-flex align-items-center" onClick={() => { handleMenuItemClick("/users"); tToggle2() }}>
                  <FiUsers size={20} className="me-2" />
                  <span>{t("Users")}</span>
                </Link>
              </li>
            )}
            {availablePaths.includes("/solutions") && (
              <li>
                <Link to="/solutions" className="waves-effect d-flex align-items-center" onClick={() => { handleMenuItemClick("/solutions"); tToggle2() }}>
                  <AiOutlineSolution size={20} className="me-2" />
                  <span>{t("Solutions")}</span>
                </Link>
              </li>
            )}
            {/* {permissionNames?.includes("Reason List") && (
              <li>
                <Link to="/reasonsMaster" className="waves-effect d-flex align-items-center" onClick={() => { handleMenuItemClick("/reasonsMaster"); tToggle2() }}>
                  <AiOutlineSolution size={20} className="me-2" />
                  <span>{t("Reasons Master")}</span>
                </Link>
              </li>
            )} */}
            {availablePaths.includes("/sebelUsers") && (
              <li>
                <Link to="/sebelUsers" className="waves-effect d-flex align-items-center" onClick={() => { handleMenuItemClick("/sebelUsers"); tToggle2() }}>
                  <FaUsersRectangle size={22} className="me-2" />
                  <span>{t("Siebel Users")}</span>
                </Link>
              </li>
            )}
            {availablePaths.includes("/shifts") && (
              <li>
                <Link to="/shifts" className="waves-effect" onClick={() => { handleMenuItemClick("/shifts"); tToggle2() }}>
                  <IoTimeOutline size={23} className="me-2 " />
                  <span>{t("Shifts")}</span>
                </Link>
              </li>
            )}
            {availablePaths.includes("/branches") && (
              <li>
                <Link
                  to="/branches"
                  className="waves-effect d-flex align-items-center"
                  onClick={() => { handleMenuItemClick("/branches"); tToggle2() }}
                >
                  <AiOutlineBranches size={23} className="me-2" />
                  <span>{t("Branches")}</span>
                </Link>
              </li>
            )}
            {availablePaths.includes("/teams") && (
              <li>
                <Link
                  to="/teams"
                  className="waves-effect d-flex align-items-center"
                  onClick={() => { handleMenuItemClick("/teams"); tToggle2(); }}
                >
                  <RiTeamLine size={23} className="me-2" />
                  <span>{t("Teams")}</span>
                </Link>
              </li>
            )}
            {availablePaths.includes("/zones") && (
              <li>
                <Link
                  to="/zones"
                  className="waves-effect d-flex align-items-center"
                  onClick={() => { handleMenuItemClick("/zones"); tToggle2(); }}
                >
                  <PiMapPinArea size={23} className="me-2" />
                  <span>{t("Zones")}</span>
                </Link>
              </li>
            )}
            {availablePaths.includes("/areas") && (
              <li>
                <Link
                  to="/areas"
                  className="waves-effect d-flex align-items-center"
                  onClick={() => { handleMenuItemClick("/areas"); tToggle2(); }}
                >
                  <IoLocationOutline size={22} className="me-2" />
                  <span>{t("Areas")}</span>
                </Link>
              </li>
            )}
            {/* {availablePaths.includes("/checklists") && (
              <li>
                <Link to="/checklists" className="waves-effect" onClick={() => handleMenuItemClick("/checklists")}>
                  <i className="ti-package"></i>
                  <span>{t("Check Lists")}</span>
                </Link>
              </li>
            )} */}
            {(availablePaths.includes("/permissions") || availablePaths.includes("/roles") || availablePaths.includes("/createRole")) && (<li>
              <Link
                to="/#"
                className="has-arrow waves-effect"
                onClick={() => { handleMenuItemClick("/rolesAndPermissions") }}
                style={getActiveItemStyle("/rolesAndPermissions")}
              >
                <LuUserRoundPen size={21} className="me-2 mb-1" />
                <span>{t("Roles And Permissions")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                {(availablePaths.includes("/roles") || availablePaths.includes("/createRole")) && (
                  <li>
                    <Link
                      to="/roles"
                      className="waves-effect"
                      onClick={() => { handleMenuItemClick("/roles"); tToggle2(); }}
                      style={getActiveItemStyle("/roles")}
                    >
                      <LuUserRoundPen size={20} className="me-2 mb-1" />
                      <span>{t("Roles")}</span>
                    </Link>
                  </li>
                )}
                {availablePaths.includes("/permissions") && (
                  <li>
                    <Link
                      to="/permissions"
                      className="waves-effect"
                      onClick={() => { handleMenuItemClick("/permissions"); tToggle2(); }}
                      style={getActiveItemStyle("/permissions")}
                    >
                      <LuUserRoundPen size={20} className="me-2 mb-1" />
                      <span>{t("Permissions")}</span>
                    </Link>
                  </li>
                )}
              </ul>
            </li>)}
            {(availablePaths.includes("/workOrderCancellations") || availablePaths.includes("/workorders") || availablePaths.includes("/createWorkOrder") || availablePaths.includes("/workOrderExtentions")) && (<li>
              <Link
                to="/#"
                className="has-arrow waves-effect"
                onClick={() => { handleMenuItemClick("/workOrders") }}
                style={getActiveItemStyle("/workOrders")}
              >
                <AiOutlineFileText size={23} className="me-2 mb-1" />
                <span>{t("Work Orders")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                {(availablePaths.includes("/workorders") || availablePaths.includes("/createWorkOrder")) && (
                  <li>
                    <Link
                      to="/workorders"
                      className="waves-effect"
                      onClick={() => { handleMenuItemClick("/workorders"); tToggle2(); }}
                      style={getActiveItemStyle("/workorders")}
                    >
                      <AiOutlineFileText size={20} className="me-2" />
                      <span>{t("Work Orders")}</span>
                    </Link>
                  </li>
                )}
                {availablePaths.includes("/workOrderCancellations") && (
                  <li>
                    <Link
                      to="/workOrderCancellations"
                      className="waves-effect"
                      onClick={() => { handleMenuItemClick("/workOrderCancellations"); tToggle2(); }}
                      style={getActiveItemStyle("/workOrderCancellations")}
                    >
                      <AiOutlineCloseCircle size={20} className="me-2" />
                      <span>{t("Cancellations")}</span>
                    </Link>
                  </li>
                )}
                {availablePaths.includes("/workOrderExtentions") && (
                  <li>
                    <Link to="/workOrderExtentions" className="waves-effect d-flex align-items-center" onClick={() => { handleMenuItemClick("/workOrderExtentions"); tToggle2(); }}
                      style={getActiveItemStyle("/workOrderExtentions")}>
                      <AiOutlineClockCircle size={20} className="me-2" />
                      <span>{t("Extentions")}</span>
                    </Link>
                  </li>
                )}
              </ul>
            </li>)}
            {(availablePaths.includes("/SiteSurveyCancellations") || availablePaths.includes("/sitesurveys") || availablePaths.includes("/createSiteSurvey") || availablePaths.includes("/editSiteSurvey") || availablePaths.includes("/SiteSurveyExtensions") || availablePaths.includes("/SiteSurveyDetails")) && (<li>
              <Link
                to="/#"
                className="has-arrow waves-effect"
                onClick={() => { handleMenuItemClick("/SiteSurveys") }}
                style={getActiveItemStyle("/SiteSurveys")}
              >
                <LiaClipboardListSolid size={23} className="me-2 mb-1" />

                <span>{t("Site Surveys")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                {(availablePaths.includes("/sitesurveys") || availablePaths.includes("/createSiteSurvey") || availablePaths.includes("/editSiteSurvey") || availablePaths.includes("/SiteSurveyDetails")) && (
                  <li>
                    <Link
                      to="/SiteSurveys"
                      className="waves-effect"
                      onClick={() => { handleMenuItemClick("/sitesurveys"); tToggle2(); }}
                      style={getActiveItemStyle("/sitesurveys")}
                    >
                      <LiaClipboardListSolid size={20} className="me-2" />
                      <span>{t("Site Surveys")}</span>
                    </Link>
                  </li>
                )}
                {availablePaths.includes("/SiteSurveyCancellations") && (
                  <li>
                    <Link
                      to="/SiteSurveyCancellations"
                      className="waves-effect"
                      onClick={() => { handleMenuItemClick("/SiteSurveyCancellations"); tToggle2(); }}
                      style={getActiveItemStyle("/SiteSurveyCancellations")}
                    >
                      <AiOutlineCloseCircle size={20} className="me-2" />
                      <span>{t("Cancellations")}</span>
                    </Link>
                  </li>
                )}
                {availablePaths.includes("/SiteSurveyExtensions") && (
                  <li>
                    <Link to="/SiteSurveyExtensions" className="waves-effect d-flex align-items-center" onClick={() => { handleMenuItemClick("/SiteSurveyExtensions"); tToggle2(); }}
                      style={getActiveItemStyle("/SiteSurveyExtensions")}>
                      <AiOutlineClockCircle size={20} className="me-2" />
                      <span>{t("Extentions")}</span>
                    </Link>
                  </li>
                )}
              </ul>
            </li>)}
            {(availablePaths.includes("/calendar") || availablePaths.includes("/holidays")) && (<li>
              <Link
                to="/#"
                className="has-arrow waves-effect"
                onClick={() => { handleMenuItemClick("/Calendar") }}
                style={getActiveItemStyle("/Calendar")}
              >
                <RxCalendar size={20} className="me-2 mb-1" />
                <span>{t("Calendar")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                {availablePaths.includes("/holidays") && (
                  <li>
                    <Link to="/holidays" className="waves-effect" onClick={() => { handleMenuItemClick("/holidays"); tToggle2(); }}
                      style={getActiveItemStyle("/holidays")}>
                      <BsCalendar4Event size={16} className="me-2 mb-1" />
                      <span>{t("Holidays")}</span>
                    </Link>
                  </li>
                )}
                {availablePaths.includes("/calendar") && (
                  <li>
                    <Link to="/calendar" className="waves-effect" onClick={() => { handleMenuItemClick("/calendar"); tToggle2(); }}
                      style={getActiveItemStyle("/calendar")}>
                      <IoEyeOutline size={20} className="me-2 mb-1" />
                      <span>{t("View")}</span>
                    </Link>
                  </li>
                )}
              </ul>
            </li>)}
            {(availablePaths.includes("/feedbacks") || availablePaths.includes("/customerFeedBacks")) && (<li>
              <Link
                to="/#"
                className="has-arrow waves-effect"
                onClick={() => { handleMenuItemClick("/Feedbacks") }}
                style={getActiveItemStyle("/Feedbacks")}
              >
                <VscFeedback size={22} className="me-2 mb-1" />
                <span>{t("Feedbacks")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                {availablePaths.includes("/feedbacks") && (
                  <li>
                    <Link to="/feedbacks" className="waves-effect d-flex align-items-center" onClick={() => { handleMenuItemClick("/feedbacks"); tToggle2(); }} style={getActiveItemStyle("/feedbacks")}>
                      < AiOutlineComment size={23} className="me-2 mt-1" />
                      <span>{t("Feedbacks")}</span>
                    </Link>
                  </li>
                )}
                {availablePaths.includes("/customerFeedBacks") && (
                  <li>
                    <Link to="/customerFeedBacks" className="waves-effect d-flex align-items-center" onClick={() => { handleMenuItemClick("/customerFeedBacks"); tToggle2(); }} style={getActiveItemStyle("/customerFeedBacks")}>
                      < LiaComment size={22} className="me-2 mt-1" />
                      <span>{t("Customer Feedbacks")}</span>
                    </Link>
                  </li>
                )}
              </ul>
            </li>)}
            {(availablePaths.includes("/performanceReport") || availablePaths.includes("/workOrderReport") || availablePaths.includes("/pendingWorkOrders") || availablePaths.includes("/completedWorkOrders") || availablePaths.includes("/upcomingWorkOrders") || availablePaths.includes("/ongointWorkOrders")) && (<li>
              <Link
                to="/#"
                className="has-arrow waves-effect"
                onClick={() => { handleMenuItemClick("/performanceReport"); }}
                style={getActiveItemStyle("/performanceReport")}
              >
                <IoPieChartOutline size={22} className="me-2 mb-1" />
                <span>{t("Reports")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                {availablePaths.includes("/performanceReport") && (
                  <li>
                    <Link to="/performanceReport" className="waves-effect" onClick={() => { handleMenuItemClick("/performanceReport"); tToggle2(); }}
                      style={getActiveItemStyle("/performanceReport")}>
                      <GrDocumentPerformance size={18} className="me-2 mb-1" />
                      <span>{t("Performance Report")}</span>
                    </Link>
                  </li>
                )}
                {availablePaths.includes("/workOrderReport") && (
                  <li>
                    <Link to="/workOrderReport" className="waves-effect" onClick={() => { handleMenuItemClick("/workOrderReport"); tToggle2(); }}
                      style={getActiveItemStyle("/workOrderReport")}>
                      <IoListOutline size={18} className="me-2 mb-1" />
                      <span>{t("WorkOrder Report")}</span>
                    </Link>
                  </li>
                )}
                {availablePaths.includes("/upcomingWorkOrders") && (
                  <li>
                    <Link to="/upcomingWorkOrders" className="waves-effect" onClick={() => { handleMenuItemClick("/upcomingWorkOrders"); tToggle2(); }}
                      style={getActiveItemStyle("/upcomingWorkOrders")}>
                      <AiOutlineCalendar size={20} className="me-2 mb-1" />
                      <span>{t("Upcoming WOS")}</span>
                    </Link>
                  </li>
                )}
                {availablePaths.includes("/pendingWorkOrders") && (
                  <li>
                    <Link to="/pendingWorkOrders" className="waves-effect" onClick={() => { handleMenuItemClick("/pendingWorkOrders"); tToggle2(); }}
                      style={getActiveItemStyle("/pendingWorkOrders")}>
                      <AiOutlineClockCircle size={18} className="me-2 mb-1" />
                      <span>{t("Pending WOS")}</span>
                    </Link>
                  </li>
                )}
                {availablePaths.includes("/ongointWorkOrders") && (
                  <li>
                    <Link to="/ongointWorkOrders" className="waves-effect" onClick={() => { handleMenuItemClick("/ongointWorkOrders"); tToggle2(); }}
                      style={getActiveItemStyle("/ongointWorkOrders")}>
                      <HiOutlineRefresh size={20} className="me-2 mb-1" />
                      <span>{t("Ongoing WOS")}</span>
                    </Link>
                  </li>
                )}
                {availablePaths.includes("/completedWorkOrders") && (
                  <li>
                    <Link to="/completedWorkOrders" className="waves-effect" onClick={() => { handleMenuItemClick("/completedWorkOrders"); tToggle2(); }}
                      style={getActiveItemStyle("/completedWorkOrders")}>
                      <PiListChecks size={20} className="me-2 mb-1" />
                      <span>{t("Completed WOS")}</span>
                    </Link>
                  </li>
                )}
              </ul>
            </li>)}
            {availablePaths.includes("/settings") && (
              <li>
                <Link to="/settings" className="waves-effect d-flex align-items-center" onClick={() => { handleMenuItemClick("/users"); tToggle2(); }}>
                  <IoSettingsOutline size={22} className="me-2 mt-1" />
                  <span>{t("Settings")}</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  permissions: PropTypes.array,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
